
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Component Sticker Sheet`}</h3>
    <ul>
      <li parentName="ul">{`Added PX Blue components (Scorecard, Empty State, Channel Value, Heroes, List Item Tag, Info List Item, Nav Rail, Drawer, Dropdown Toolbar) to our `}<a parentName="li" {...{
          "href": "https://www.figma.com/community/file/852558784352181868"
        }}>{`Sticker Sheet`}</a></li>
      <li parentName="ul">{`Added several PX Blue design patterns (Progress Indicators, Pagers, Panels)`}</li>
      <li parentName="ul">{`Added more Material UI components (Bottom Sheets, Chips, Snackbars, Cards, Sliders, Tooltips, Switches, Avatars, FABs)`}</li>
    </ul>
    <h3>{`Design Patterns`}</h3>
    <ul>
      <li parentName="ul">{`Re-organized and added new content to explain our `}<a parentName="li" {...{
          "href": "/patterns"
        }}>{`design patterns`}</a>{`.`}</li>
      <li parentName="ul">{`Added more images and design specifications.`}</li>
      <li parentName="ul">{`Completed migration of `}<a parentName="li" {...{
          "href": "https://github.com/pxblue/angular-design-patterns"
        }}>{`Angular`}</a>{`, `}<a parentName="li" {...{
          "href": "https://github.com/pxblue/ionic-design-patterns"
        }}>{`Ionic`}</a>{`, and `}<a parentName="li" {...{
          "href": "https://github.com/pxblue/react-native-design-patterns"
        }}>{`React Native`}</a>{` design patterns into a single example repository.`}</li>
    </ul>
    <h3>{`Documentation Site`}</h3>
    <ul>
      <li parentName="ul">{`Added documentation around `}<a parentName="li" {...{
          "href": "/design/accessibility"
        }}>{`accessibility standards`}</a>{`, how to design `}<a parentName="li" {...{
          "href": "/design/websites"
        }}>{`websites`}</a>{`, and `}<a parentName="li" {...{
          "href": "/style/illustrations"
        }}>{`illustrations`}</a>{`.`}</li>
    </ul>
    <h3>{`Component Libraries`}</h3>
    <ul>
      <li parentName="ul">{`Added new components to our `}<a parentName="li" {...{
          "href": "https://pxblue-components.github.io/angular"
        }}>{`Angular`}</a>{`, `}<a parentName="li" {...{
          "href": "https://pxblue-components.github.io/react"
        }}>{`React`}</a>{`, and `}<a parentName="li" {...{
          "href": "https://pxblue-components.github.io/react-native"
        }}>{`React Native`}</a>{` component libraries:`}
        <ul parentName="li">
          <li parentName="ul">{`For Angular, we now have components for `}<a parentName="li" {...{
              "href": "https://pxblue-components.github.io/angular/?path=/info/components-dropdown-toolbar--readme"
            }}>{`Dropdown Toolbar`}</a>{` and added a `}<a parentName="li" {...{
              "href": "https://pxblue-components.github.io/angular/?path=/story/components-drawer--with-a-nav-rail"
            }}>{`nav-rail variant`}</a>{` to our Drawer component.`}</li>
          <li parentName="ul">{`For React, we now have components for `}<a parentName="li" {...{
              "href": "https://pxblue-components.github.io/react/?path=/info/components-dropdown-toolbar--readme"
            }}>{`Dropdown Toolbar`}</a>{`.`}</li>
          <li parentName="ul">{`For React Native, we now components for `}<a parentName="li" {...{
              "href": "https://pxblue-components.github.io/react-native/?path=/info/components-documentation--spacer"
            }}>{`Spacer`}</a>{` and `}<a parentName="li" {...{
              "href": "https://pxblue-components.github.io/react-native/?path=/info/components-documentation--list-item-tag"
            }}>{`List Item Tag`}</a>{`.`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Enhanced our component libraries to support right-to-left languages and developed / integrated a `}<a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@pxblue/storybook-rtl-addon"
        }}>{`RTL toggle`}</a>{` into our storybook demos.`}</li>
    </ul>
    <h3>{`Reusable Workflows`}</h3>
    <ul>
      <li parentName="ul">{`Reusable `}<a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@pxblue/react-auth-workflow"
        }}>{`Authentication Workflow`}</a>{` for React.`}</li>
    </ul>
    <h3>{`Miscellaneous`}</h3>
    <ul>
      <li parentName="ul">{`Added new `}<a parentName="li" {...{
          "href": "https://github.com/pxblue/progress-icons/tree/master"
        }}>{`progress icons`}</a>{` and an optional percentage label.`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;